import React from 'react';
import PropTypes from 'prop-types';
import { Card, Title, BtnGroup, Option } from '../survey.css';

const HowSoon = ({ setHowSoon, nextStep, queryParams }) => (
  <Card>
    <Title>
      How soon are you
      <br /> looking to sell?
    </Title>

    <BtnGroup
      circles={
        queryParams && queryParams.circles && queryParams.circles === 'true'
      }
    >
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setHowSoon('ASAP', nextStep)}
      >
        ASAP
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setHowSoon('1-3 Months', nextStep)}
      >
        1-3 Months
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setHowSoon('3-6 Months', nextStep)}
      >
        3-6 Months
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setHowSoon('6-12 Months', nextStep)}
      >
        6-12 Months
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setHowSoon('12+ Months', nextStep)}
      >
        12+ Months
      </Option>
    </BtnGroup>
  </Card>
);

HowSoon.propTypes = {
  setHowSoon: PropTypes.func.isRequired,
  nextStep: PropTypes.number.isRequired,
  queryParams: PropTypes.object,
};

export default HowSoon;
